import { render, staticRenderFns } from "./ZProfileImage.vue?vue&type=template&id=bd724044&scoped=true&"
import script from "./ZProfileImage.vue?vue&type=script&lang=js&"
export * from "./ZProfileImage.vue?vue&type=script&lang=js&"
import style0 from "./ZProfileImage.vue?vue&type=style&index=0&id=bd724044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd724044",
  null
  
)

export default component.exports